import { cx } from "@jugl-web/utils";
import type { FC, ReactNode } from "react";
import { VoiceOrbAnimation } from "../VoiceOrbAnimation";
import { WaveformAnimation } from "../WaveformAnimation";
import { ReactComponent as CloseIcon } from "./assets/close.svg";
import { ReactComponent as MicIcon } from "./assets/mic.svg";
import { ReactComponent as MicMutedIcon } from "./assets/mic-muted.svg";
import { ChatBotUIVoiceMode } from "../../types";

interface VoiceModePanelProps extends ChatBotUIVoiceMode {
  className?: string;
}

export const VoiceModePanel: FC<VoiceModePanelProps> = ({
  waveformSamples,
  isConnecting,
  isMuted,
  isAgentSpeaking,
  className,
  onExit,
  onMuteToggle,
}) => {
  return (
    <div
      className={cx(
        "flex h-full w-full max-w-[660px] flex-col overflow-hidden",
        className
      )}
    >
      <div className="flex min-h-0 flex-1 items-center justify-center overflow-hidden">
        <VoiceOrbAnimation isActive={isAgentSpeaking} isFaded={isConnecting} />
      </div>
      <div className="flex h-12 shrink-0 items-center justify-between px-10">
        <ControlButton onClick={onExit}>
          <CloseIcon />
        </ControlButton>
        <span className="text-sm leading-[150%] font-normal text-dark-600">
          {isConnecting ? (
            <span className="animate-fade-in">Connecting...</span>
          ) : isMuted ? (
            <span className="animate-fade-in">You&apos;re on mute</span>
          ) : (
            <div className="animate-fade-in">
              <WaveformAnimation
                data={waveformSamples}
                isActive
                numberOfBars={20}
              />
            </div>
          )}
        </span>
        <ControlButton onClick={onMuteToggle}>
          {isMuted ? <MicMutedIcon /> : <MicIcon />}
        </ControlButton>
      </div>
    </div>
  );
};

interface ControlButtonProps {
  children: ReactNode;
  onClick: () => void;
}

const ControlButton: FC<ControlButtonProps> = ({ children, onClick }) => {
  return (
    <button
      type="button"
      className="flex h-12 w-12 shrink-0 cursor-pointer items-center justify-center rounded-[10px] border border-solid border-grey-300 bg-transparent transition hover:bg-grey-100 active:scale-95"
      onClick={onClick}
    >
      {children}
    </button>
  );
};
